import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_ShortUrl = {
    _v1: {
        getShortUrl: { method: HttpMethod.GET, path: 'v1/short-url/get-short-url', timeout: Minute }
    }
};
//# sourceMappingURL=api-def.js.map